module.exports = __webpack_public_path__ + "img/4.d8f9f8c9.jpg";